/**
 * This middleware sends tracking calls based on actions being dispatched
 */

import { trackActivateCodeInvalid } from 'lib/omniture';
import routingSelector from 'common/selectors/routingSelector';
import { GENERIC_ERROR, INVALID_ERROR } from 'webapp/page/Activate/actions';

export default (store) => (next) => (action) => {
    const state = store.getState();
    const { providerDialog: { providers = [] } = {} } = state;
    const {
        locationBeforeTransitions: {
            query: { device, deviceType }
        }
    } = routingSelector(state);

    const { type, providerId } = action;
    const trackingDevice = device || deviceType;
    const trackingProvider = providers.filter(provider => provider.abbreviation === providerId).shift();

    if (type === GENERIC_ERROR || type === INVALID_ERROR) {
        trackActivateCodeInvalid(trackingDevice, trackingProvider);
    }

    return next(action);
};



// WEBPACK FOOTER //
// ./app/common/middlewares/trackingMiddleware.js